import React, { FunctionComponent } from 'react';

import { SvgProps, propsHelperRem } from '@/shared/lib/propsHelper';

const Play: FunctionComponent<SvgProps> = (props) => (
    <svg {...propsHelperRem(2.4, 2.4, props)}>
        <path d="M6 3.375L21 12L6 20.625V3.375Z" fill="white" />
    </svg>
);

export default Play;
